export default import.meta.ROLLDOWN_FILE_URL_6FZledplxBd88wbbVe1skw